import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  useGetSelectedTeamUserQuery,
} from "../../Services/email/EmailInbox";

import {
  Modal,
  Box,
  Button,
  Select,
  MenuItem,
  Checkbox,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useMeeQuery } from "../../Services/settingsAPIs/CommonAPI";
import { Loader } from "react-bootstrap-typeahead";
import { useBulkLeadAssignMutation } from "../../Services/campign/campignList";

interface IProps {
  closeBulkModal: () => void;
  selectedCampaign: any;
  refetch: any;
}

const BulkAssigneeLeadModel: React.FC<IProps> = ({
  closeBulkModal,
  selectedCampaign,
  refetch,
}) => {
  const userToken = JSON.parse(localStorage.getItem("user-token") || "{}");
  const [selectedTeam, setSelectedTeam] = useState<string>("");
  const [addUser, setAddUser] = useState<boolean>(false);
  const [selectedUserId, setSelectedUserId] = useState<string>("");
  const [isLoading1, setIsLoading1] = useState<boolean>(false);
  const [isUserLoading, setIsUserLoading] = useState(false);
  const [theTeams, setTheTeams] = useState([]);
  const { data } = useMeeQuery({});



  const { data: selectedTeamUser, status: usersStatus } =
    useGetSelectedTeamUserQuery(selectedTeam, {
      skip: !selectedTeam,
    });
  console.log(selectedTeam, "..");
  const [UpdateBulkLeadAssignee] = useBulkLeadAssignMutation();

  useEffect(() => {
    if (selectedTeamUser) {
      setAddUser(true);
    }
  }, [selectedTeamUser]);
  console.log(selectedTeamUser, "user");

  useEffect(() => {
    if (usersStatus === "pending") {
      setIsUserLoading(true);
    } else {
      setIsUserLoading(false);
    }
  }, [usersStatus]);
  useEffect(() => {

    return setTheTeams(data?.teams);

  }, [data]);

  const changeTeamHandler: any = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setSelectedTeam(event.target.value as string);
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 120,
      },
    },
  };

  const assignHandler = async () => {
    setIsLoading1(true);
    try {
      const payload = {
        lead_ids: selectedCampaign,
        // assignee_id: selectedUserId,
        // team_assignee_id: selectedTeam,
      };
      console.log(selectedUserId, "selectedUserIdselectedUserId");
      await UpdateBulkLeadAssignee({
        body: payload,
        selectedCampaign,
        selectedUserId,
      });

      toast.success(`Lead successfully assigned`);
      refetch();
      closeBulkModal();
      setIsLoading1(false);
    } catch (err) {
      toast.error("Failed to assign. Please try again.");
      console.error("Error assigning user:", err);
      setIsLoading1(false);
    } finally {
      setIsLoading1(false);
    }
  };

  return (
    <Modal
      open={true}
      onClose={(event, reason) => {
        if (reason && reason === "backdropClick") return;
        closeBulkModal();
      }}
      aria-labelledby="assign-team-modal-title"
      aria-describedby="assign-team-modal-description"
    >
      <Box
        sx={{
          padding: "1rem",
          backgroundColor: "white",
          margin: "auto",
          width: "400px",
          height: "300px",
          borderRadius: "8px",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          position: "absolute",
          boxShadow: 24,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            onClick={closeBulkModal}
            style={{ minWidth: "auto", padding: "0.5rem" }}
          >
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </div>
        <div>
          <div className="change-assignee-section">
            <div className="change-assignee-section--body mt-4">
              <InputLabel>Team</InputLabel>
              <FormControl variant="standard" className="full-width w-100 mt-4">
                <Select
                  value={selectedTeam}
                  onChange={changeTeamHandler}
                  displayEmpty
                  style={{ paddingLeft: "1rem" }}
                  MenuProps={MenuProps}
                >
                  <MenuItem value="" disabled>
                    Select Team
                  </MenuItem>
                  {theTeams &&
                    theTeams.length > 0 &&
                    theTeams.map((team: { id: number; name: string }) => (
                      <MenuItem key={team.id} value={team.id}>
                        {team.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>
          </div>
          <div className="mt-4">
            <Checkbox
              className="example-margin"
              checked={addUser}
              onChange={() => setAddUser(!addUser)}
              disabled={!selectedTeam}
            />
            Assign to user
          </div>
          {addUser && (
            <div>
              <div className="change-assignee-section">
                <div className="change-assignee-section--body mt-4">
                  <InputLabel>User</InputLabel>
                  {isUserLoading ? (
                    <div>
                      <Loader />
                    </div>
                  ) : (
                    <FormControl
                      variant="standard"
                      className="full-width w-100 mt-4"
                    >
                      <Select
                        value={selectedUserId}
                        onChange={(event) =>
                          setSelectedUserId(event.target.value as string)
                        }
                        displayEmpty
                        disabled={!selectedTeam}
                        MenuProps={MenuProps}
                        style={{ paddingLeft: "1rem" }}
                      >
                        <MenuItem value="" disabled>
                          Select User
                        </MenuItem>
                        {selectedTeamUser?.map(
                          (user: { id: number; username: string }) => (
                            <MenuItem key={user.id} value={user.id}>
                              {user.username}
                            </MenuItem>
                          )
                        )}
                      </Select>
                    </FormControl>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        <div
          style={{
            position: "absolute",
            bottom: ".6rem",
            left: "50%",
            transform: "translateX(-50%)",
            width: "90%",
          }}
        >
          <Button
            className="btn btn-primary w-100 "
            onClick={assignHandler}
            disabled={!selectedTeam || !addUser || !selectedUserId}
          >
            {isLoading1 ? (
              <>
                Assigning... <Loader />
              </>
            ) : (
              "Assign"
            )}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default BulkAssigneeLeadModel;
